import api from "./Interceptor";

const BASE_URL = process.env.REACT_APP_BACKEND_URL;

export const getAllBlogs = async (page = 0, rowsPerPage) => {
  try {
    const response = await api.get(
      `${BASE_URL}/blog?page=${page}&limit=${rowsPerPage}&status=Published`
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching blogs:", error);
    throw error?.response?.data || new Error("Failed to fetch blogs");
  }
};

export const getBlogDetails = async (blogId) => {
  try {
    const response = await api.get(`${BASE_URL}/blog/${blogId}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching blog details:", error);
    throw error?.response?.data || new Error("Failed to fetch blog details");
  }
};

export const addComment = async (blogId, payload) => {
  try {
    const response = await api.put(
      `${BASE_URL}/blog/${blogId}/add-comment`,
      payload,
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching blog details:", error);
    throw error?.response?.data || new Error("Failed to fetch blog details");
  }
};
